import { render, staticRenderFns } from "./MainTitleBack.vue?vue&type=template&id=47510c26&scoped=true"
import script from "./MainTitleBack.vue?vue&type=script&lang=js"
export * from "./MainTitleBack.vue?vue&type=script&lang=js"
import style0 from "./MainTitleBack.vue?vue&type=style&index=0&id=47510c26&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47510c26",
  null
  
)

export default component.exports